import { defineMessages } from 'react-intl';

export default defineMessages({
  addPaymentMethod: {
    id: 'payment.add.credit.card.button.message',
    defaultMessage: 'Add credit card'
  }
});
